import { Skeleton } from '@mui/material';

export function LinkSkeleton() {
  return <Skeleton variant="rectangular" width={120} height={32} />;
}
